import { CompanyFormState } from "shared/utils/fieldsHelper/companyFields";
import { MergeFormSection } from "components/MainSectionTemplate/types";
import React from "react";

export const profileSection = (
  existingCompany: CompanyFormState,
  sourceCompany: CompanyFormState,
  currentCompany: CompanyFormState,
  setCurrentCompany: (company: CompanyFormState) => void
): MergeFormSection => ({
  key: "profile",
  title: RESX.Company.Profile,
  fields: [{
    key: "artist",
    label: site.currentEnvironment.functionGroups.artist.singular,
    supportArticleId: serverReference.supportArticleIds.artistProfile,
    currentValue: currentCompany.profile.isArtist,
    existingValue: existingCompany.profile.isArtist,
    sourceValue: sourceCompany.profile.isArtist,
    isEmpty: () => false,
    render: (isArtist: server.dto.IsArtistTypes) => <span>
      {isArtist === "no" && RESX.GeneralLabels.No}
      {isArtist === "active" && RESX.GeneralLabels.Yes}
      {isArtist === "noLongerActive" && RESX.Artist.YesButNoLongerActive}
    </span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      profile: {
        ...currentCompany.profile,
        isArtist: sourceCompany.profile.isArtist,
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      profile: {
        ...currentCompany.profile,
        isArtist: existingCompany.profile.isArtist,
      },
    }),
  }, {
    key: "venue",
    label: site.currentEnvironment.functionGroups.venue.singular,
    supportArticleId: serverReference.supportArticleIds.venueProfile,
    currentValue: currentCompany.profile.isVenue,
    existingValue: existingCompany.profile.isVenue,
    sourceValue: sourceCompany.profile.isVenue,
    isEmpty: () => false,
    render: (isVenue: server.dto.IsVenueTypes) => <span>
      {isVenue === "no" && RESX.GeneralLabels.No}
      {isVenue === "active" && RESX.GeneralLabels.Yes}
    </span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      profile: {
        ...currentCompany.profile,
        isVenue: sourceCompany.profile.isVenue,
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      profile: {
        ...currentCompany.profile,
        isVenue: existingCompany.profile.isVenue,
      },
    }),
  }, {
    key: "promoter",
    label: site.currentEnvironment.functionGroups.promoter.singular,
    supportArticleId: serverReference.supportArticleIds.promoterProfile,
    currentValue: currentCompany.profile.isPromoter,
    existingValue: existingCompany.profile.isPromoter,
    sourceValue: sourceCompany.profile.isPromoter,
    isEmpty: () => false,
    render: (isPromoter: server.dto.IsPromoterTypes) => <span>
      {isPromoter === "no" && RESX.GeneralLabels.No}
      {isPromoter === "active" && RESX.GeneralLabels.Yes}
    </span>,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      profile: {
        ...currentCompany.profile,
        isPromoter: sourceCompany.profile.isPromoter,
      },
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      profile: {
        ...currentCompany.profile,
        isPromoter: existingCompany.profile.isPromoter,
      },
    }),
  }]
});